<template>
  <div style="display:flex" class="align-center">
    <div class="mr-1 mr-md-10 flex-grow-1">
      <div
        class="ml-1"
        style="white-space:nowrap;overflow:visible;"
      >{{$t('Служба технической поддержки')}}</div>
      <a class="link pa-1 primary--text" href="tel:+77172955600">
        <v-icon small color="primary" class="mr-4">phone_in_talk</v-icon>+7&nbsp;(7172)&nbsp;955-600
      </a>
      <br />
      <a class="link pa-1 primary--text" href="mailto: support_aisoip@alseco.kz">
        <v-icon small color="primary" class="mr-4">mail_outline</v-icon>support_aisoip@alseco.kz
      </a>
    </div>
    <div class="d-flex flex-grow-1">
      <div>
        <v-icon small color="primary" class="mr-4">query_builder</v-icon>
      </div>
      <span v-html="$t('syllabus')"></span>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({});
</script>